import { render } from "./SocialCauseCard.vue?vue&type=template&id=19d913c1&scoped=true"
import script from "./SocialCauseCard.vue?vue&type=script&lang=js"
export * from "./SocialCauseCard.vue?vue&type=script&lang=js"

import "@/Common/Styles/socialCauseCard.scss?vue&type=style&index=0&id=19d913c1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d913c1"]])

export default __exports__